// Generated by ts-to-zod
import { z } from 'zod';

export const fromTemplatePayloadSchema = z.object({
  uuid: z.string(),
});
